<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import CopyButton from '@/components/aml-review/CopyButton.vue';

defineProps<{ value: string; label: string; to?: RouteLocationRaw }>();
</script>

<template>
  <span class="inline-flex max-w-full min-w-0 items-center gap-x-1.5">
    <RouterLink
      v-if="to"
      :to="to"
      :title="value"
      class="truncate font-mono font-medium text-indigo-600 hover:text-indigo-700"
      data-test="entity-id-value"
    >
      {{ value }}
    </RouterLink>
    <span
      v-else
      :title="value"
      class="truncate font-mono text-gray-900"
      data-test="entity-id-value"
    >
      {{ value }}
    </span>
    <CopyButton :value="value" :label="label" />
  </span>
</template>
